import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { push } from 'connected-react-router';
import { Container, Card, Form, Spinner, Col, Row, Button, FormGroup, FormLabel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faAsterisk } from '@fortawesome/free-solid-svg-icons';
import OPFormFactory from 'src/components/forms/paymentOrder/OPFormFactory'
import { getListServicesByUserAndExerciseData } from "src/redux/administrativeService/administrativeServiceReducer";
import { tryListServicesByUserAndExercise } from "src/redux/administrativeService/administrativeServiceActionCreator";
import { clearDTOFromEmptyData, getOrderPayTypeValueToShow, orderFormsReadyToDisplay } from 'src/utils/utils';
import { tryPostOrderPay, tryListPayOrderTypes } from 'src/redux/orderPay/orderPayActionCreator';
import { setSelectedTypeOrderPay, clearSelectedTypeOrderPay } from 'src/redux/orderPay/orderPayActions'
import {
    getOrderPayCreateIsFetching,
    getOrderType,
    getPayOrderTypeListData,
    getOrderPayListIsFetching
} from 'src/redux/orderPay/orderPayReducer';
import { ORDER_PAY_LIST } from 'src/utils/constants';
import { isNotEmptyArray } from 'src/services/validationService';
import { clearOneListAdministrativeDocumentData } from 'src/redux/administrativeDocument/administrativeDocumentActions';
import { getAdministrativeDocumentIsFetching } from 'src/redux/administrativeDocument/administrativeDocumentReducer';
import { getEmail } from 'src/redux/login/loginReducer';
import { getUserListData } from 'src/redux/user/userReducer';
import { getGlobalDataSelectedPeriod } from 'src/redux/globalData/globalDataReducer';
import { showWarning } from 'src/redux/globalData/globalDataActionCreator';
import { faInfoCircle } from '../../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import { config } from 'src/env.js';
import * as SERVICES from 'src/services/subcodeServices';
import { getAccessToken } from 'src/redux/login/loginReducer';

const OrderPayNewPage = () => {

    const dispatch = useDispatch();

    const hookFormMethods = useForm();
    const { handleSubmit } = hookFormMethods;
    const [formValuesState, setFormValuesState] = useState({ legalInstruments: [], legalInstrument: {} });

    const accessToken = useSelector(state => getAccessToken(state));

    const [admServiceId, setAdmServiceId] = useState('');
    const [admServiceCode, setAdmServiceCode] = useState('');
    const [expedientesSeleccionados, setExpedientesSeleccionados] = useState([]);
    const [settlementOfAssets, setSettlementOfAssets] = useState({});
    const [proveedorSelected, setProveedorSelected] = useState('');
    const [importe, setImporte] = useState(0);
    const [existingPOrderNumber, setExistingPOrderNumber] = useState(false);
    const [admCode, setAdmCode] = useState('');
    const [admNumber, setAdmNumber] = useState('');
    const [admYear, setAdmYear] = useState('');
    const isFetching = useSelector(state => getOrderPayCreateIsFetching(state));
    let orderType = useSelector(state => getOrderType(state));
    const payOrderTypeList = useSelector(state => getPayOrderTypeListData(state)) || [];
    const orderPayListIsFetching = useSelector(state => getOrderPayListIsFetching(state));
    const [getSubcodeDetailsIsFetching, setGetSubcodeDetailsIsFetching] = useState(false);

    const OPHaberes = orderType == 'ORDEN_DE_PAGO_DE_HABERES';
    const OPHaberesMultiples = orderType == 'ORDEN_DE_PAGO_DE_HABERES_MULTIPLES';
    const OPProveedores = orderType == 'ORDEN_DE_PAGO_DE_PROVEEDORES';
    const OPSubsidios = orderType == 'ORDEN_DE_PAGO_SUBSIDIOS';
    const OPPrestamo = orderType == 'ORDEN_DE_PAGO_DE_PRESTAMO';
    const OPAportesTesoroNacional = orderType == 'ORDEN_DE_PAGO_DE_APORTES_TESORO_NACIONAL';

    const [allowSaveAmountValidation, setAllowSaveAmountValidation] = useState('');
    const allowSaveByOrderType = OPProveedores || OPSubsidios || OPPrestamo || OPAportesTesoroNacional;
    const hasReceipts = isNotEmptyArray(formValuesState?.beneficiaries?.[0]?.receipts);
    const allowSaveButton = isFetching || (allowSaveByOrderType && (isNotEmptyArray(expedientesSeleccionados) && hasReceipts ? (!hasReceipts || !allowSaveAmountValidation) : false));
    const validationSettlementOfAssets = ((orderType === 'ORDEN_DE_PAGO_DE_HABERES' || orderType === 'ORDEN_DE_PAGO_DE_HABERES_MULTIPLES') && !allowSaveAmountValidation) ? false : true;
    const isFetchingAdministrativeDocument = useSelector(state => getAdministrativeDocumentIsFetching(state));
    const email = useSelector(state => getEmail(state));
    const listUserData = useSelector(state => getUserListData(state));
    const userFound = listUserData?.records?.find(item => item.email == email);
    const globalSelectedPeriod = useSelector(state => getGlobalDataSelectedPeriod(state));

    const amountsShowValidation = (totalReceiptAmount, importe) => {
        if (totalReceiptAmount) {
            const resultCondition = totalReceiptAmount?.toFixed(2) === importe?.toFixed(2)
            setAllowSaveAmountValidation(resultCondition);
            return resultCondition;
        }
        return false;
    };

    const administrativeServiceData = useSelector(state => getListServicesByUserAndExerciseData(state))
        ?.sort((a, b) => a.code > b.code ? 1 : -1)
        ?.map(item => ({
            displayName: `${item?.code} - ${item?.name} `,
            id: item?.id,
            name: item?.name,
            code: item?.code
        }));

    const validateOrderPay = () => {
        const receiptType = formValuesState?.beneficiaries?.[0]?.receipts?.[0]?.type;
        const validate = orderType == "ORDEN_DE_PAGO_DE_PROVEEDORES" && receiptType == "CERTIFICADO_DE_OBRAS_PUBLICAS";

        if (validate) {
            const isValid = isNotEmptyArray(expedientesSeleccionados?.filter(item => item?.mappedCompleteNumber?.partidaPrincipal == "052"));
            if (!isValid) showWarning(`No se puede generar la orden de pago. Existe un certificado de obra sin una Partida Principal 052 seleccionada.`);
            return isValid;
        } else {
            return true;
        }
    };

    const onSubmitForm = async (data) => {
        // Verificar si se ha seleccionado un tipo de orden
        if (!orderType) {
            console.error("No se ha seleccionado un tipo de orden de pago");
            return false;
        }

        // Validar código de organismo
        if (data?.codigo?.length !== 4) {
            console.error("Código de organismo inválido", data?.codigo);
            return false;
        }

        let params;
        let wageManager;
        let wageManagers = [];

        // Construcción del objeto wageManager para HABERES
        if (orderType === 'ORDEN_DE_PAGO_DE_HABERES') {            
            wageManager = {
                name: settlementOfAssets?.name,
                wageLiquidationType: settlementOfAssets?.wageLiquidationType,
                netAmount: settlementOfAssets?.netAmount,
                wageManagerDetails: settlementOfAssets?.wageManagerDetails?.map(item => {
                    return {
                        concept: item?.concept,
                        subConcept: item?.subConcept,
                        item: item?.item,
                        code: item?.code,
                        periodAmount: item?.periodAmount,
                        changeAmount: item?.changeAmount
                    };
                })
            };
        }
        if (orderType === 'ORDEN_DE_PAGO_DE_HABERES_MULTIPLES') {
            const selectedPayrollIds = data.selectedPayrollIds || [];
            let payrollIds = selectedPayrollIds;
            if (typeof selectedPayrollIds === 'string') {
                try {
                    payrollIds = JSON.parse(selectedPayrollIds);
                } catch (e) {
                    console.error('Error al parsear JSON de IDs:', e);
                    payrollIds = [];
                }
            }
            wageManagers = Array.isArray(payrollIds) ? payrollIds.map(id => ({ id })) : [];
        }

        // Construcción de parámetros según el tipo
        if (orderType == 'ORDEN_DE_PAGO_DEPOSITO_INDEBIDO') {
            params = [{
                "amount": data.importe,
            }]
        } else if (OPHaberes || OPPrestamo || OPAportesTesoroNacional || OPSubsidios || OPHaberesMultiples) {
            params = expedientesSeleccionados?.map((item) => ({
                'presupuestoResponse': {
                    "amount": item.amount.toFixed(2),
                    "subCodeId": item.subCodeId || item.id,
                    "periodId": item?.code?.credit?.period?.id || null,
                    "subPartialBudget": {
                        "id": item?.subPartialBudgetSelected?.id
                    },
                    "periodRpId": item?.periodRpId || null,
                }
            }))
        }
        else {
            params = expedientesSeleccionados?.map((item) => ({
                'presupuestoResponse': {
                    "amount": item.amount.toFixed(2),
                    "subCodeId": item.subCodeId || item.id,
                    "periodId": item?.code?.credit?.period?.id || null,
                }
            }))
        }

        setGetSubcodeDetailsIsFetching(true);
        await Promise.all(
            params?.map(async (expedient) => {
                if (expedient?.presupuestoResponse?.periodId == undefined || expedient?.presupuestoResponse?.periodId == null) {
                    try {
                        const response = await SERVICES.getSubcodeDetails(
                            accessToken,
                            { subcodeId: expedient?.presupuestoResponse?.subCodeId }
                        );
                        expedient.presupuestoResponse.periodId = response?.data?.[0]?.subCode?.code?.credit?.period?.id;
                    } catch (error) {
                        console.error('Error fetching subcode details:', error);
                    }
                }
            }));
        setGetSubcodeDetailsIsFetching(false);

        const details = params;

        const administrativeDocument = {
            year: data.anio,
            number: data.correlativo,
            codeOrganism: data.codigo,
            title: data.title || "Orden de pago"
        }

        const legalInstrument = [...formValuesState.legalInstruments].shift();
        const legalInstruments = [...formValuesState.legalInstruments];
        legalInstruments.shift();

        let newFormValues = {};
        let type;

        switch (orderType) {
            case 'ORDEN_DE_PAGO_DE_PROVEEDORES':
                type = formValuesState?.beneficiaries?.[0]?.type;
                newFormValues = {
                    legalInstrument,
                    legalInstruments,
                    beneficiaries: formValuesState?.beneficiaries?.[0]?.receipts?.map(receiptObj => {
                        let beneficiarieFormat = {
                            type: type,
                            cuit: receiptObj?.cuit,
                            persona: { companyName: receiptObj?.companyName },
                            receipts: [
                                { ...receiptObj }
                            ]
                        };
                        delete beneficiarieFormat?.receipts[0]?.cuit;
                        delete beneficiarieFormat?.receipts[0]?.companyName;
                        delete beneficiarieFormat?.receipts[0]?.beneficiaryValidator;
                        delete beneficiarieFormat?.receipts[0]?.validatedCuit;
                        return beneficiarieFormat;
                    })
                }
                break;
            case 'ORDEN_DE_PAGO_SUBSIDIOS':
            case 'ORDEN_DE_PAGO_DE_PRESTAMO':
            case 'ORDEN_DE_PAGO_DE_APORTES_TESORO_NACIONAL':
                type = "SUBSIDIO";
                newFormValues = {
                    legalInstrument,
                    legalInstruments,
                    beneficiaries:
                        formValuesState?.beneficiaries?.[0]?.receipts?.map(receiptObj => {
                            let beneficiarieFormat = {
                                type: type,
                                cuit: receiptObj?.cuit,
                                persona: { companyName: receiptObj?.companyName },
                                subsidyAmount: receiptObj?.subsidyAmount,
                            };
                            return beneficiarieFormat;
                        })
                }
                break;
            default:
                newFormValues = {
                    legalInstrument,
                    legalInstruments,
                    beneficiaries: formValuesState.beneficiaries
                }
        }

        const clearInstruments = clearDTOFromEmptyData(newFormValues);

        const paymentOrderDto = {
            administrativeServiceId: admServiceId,
            administrativeDocument,
            datePaymentOrder: data.date,
            description: data.description,
            observations: data?.observations?.trim(),
            generalDescription: data?.generalDescription?.trim(),
            details,
            year: data.fiscalYearId,
            number: data.number,
            type: orderType,
            beneficiaries: data.beneficiaries,
            settlement: data.settlement,
            pertainsTo: data.pertainsTo,
            wageManager,
            wageManagers,
            agentsQuantity: data.agentsQuantity ? parseInt(data.agentsQuantity, 10) : null,
            ...clearInstruments
        };
        
        const validationResult = validateOrderPay();

        if (validationResult){
            dispatch(tryPostOrderPay(paymentOrderDto))
                .then(response => {
                    if (response?.status > 199 && response?.status < 300) {
                        dispatch(push(ORDER_PAY_LIST));
                    } else {
                        console.error("Error en la respuesta:", response);
                    }
                })
                .catch(error => {
                    console.error("Error al llamar a la API:", error);
                });
        } else {
            console.error("La validación falló, no se envía la orden");
        }
    }

    const onSelectOrderType = v => {
        const params = v.target.value;
        setFormValuesState({ legalInstruments: [], legalInstrument: {} })
        dispatch(setSelectedTypeOrderPay(params));
        setExistingPOrderNumber(false);
    };

    Object.assign(hookFormMethods, {
        admServiceId, setAdmServiceId, administrativeServiceData,
        expedientesSeleccionados, setExpedientesSeleccionados,
        settlementOfAssets, setSettlementOfAssets,
        setProveedorSelected, importe, setImporte,
        formValuesState, setFormValuesState, amountsShowValidation, setAllowSaveAmountValidation,
        orderType, existingPOrderNumber, setExistingPOrderNumber, admServiceCode, setAdmServiceCode,
        admCode, admNumber, admYear, setAdmCode, setAdmNumber, setAdmYear
    });

    useEffect(() => {
        dispatch(clearSelectedTypeOrderPay());
        dispatch(tryListPayOrderTypes());
        dispatch(clearOneListAdministrativeDocumentData());
        dispatch(tryListServicesByUserAndExercise(userFound?.id, globalSelectedPeriod?.id));
    }, []);

    return <>
        <Container fluid>
            <Card className='mb-5'>
                <Card.Header className='d-flex justify-content-between'>
                    <h1 className="h6 mt-1 mb-0">Nueva Orden de Pago</h1>
                    <a className='text-white' target="_blank" href={config.apis.baseDeConocimientos.URL}>
                        <FontAwesomeIcon icon={faInfoCircle} className='mr-2' />
                        <small>Ver manual de uso</small>
                    </a>
                </Card.Header>
                <Card.Body >
                    <span className='text-danger d-flex mandatory-label justify-content-start font-weight-bold font-italic align-items-center'>
                        <FontAwesomeIcon icon={faAsterisk} className="mr-2 text-danger mandatory-asterisk" />
                        Obligatorio
                    </span>
                    <FormProvider {...hookFormMethods}>
                        <Form className='mt-4 text-black-color' onSubmit={e => {
                            e.preventDefault();
                            handleSubmit(onSubmitForm)(e);
                        }}>

                            <FormGroup as={Row}>
                                <FormLabel className='text-right text-black-color pr-3 d-flex mandatory-label align-items-center' column sm={4}>
                                    <FontAwesomeIcon icon={faAsterisk} className="mr-2 text-danger mandatory-asterisk" />
                                    Tipo de Orden de Pago:
                                </FormLabel>
                                <Col sm={4}>
                                    <Form.Control
                                        as="select"
                                        name="payOrderType"
                                        onChange={onSelectOrderType}
                                        className={"text-black-color"}
                                        disabled={orderPayListIsFetching}
                                        required>
                                        <option value={''}>Seleccione una opcion...</option>
                                        {
                                            orderFormsReadyToDisplay(payOrderTypeList)?.map((item, index) => (
                                                <option className='text-black-color' value={item} key={index}>
                                                    {getOrderPayTypeValueToShow(item)}
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Col>
                            </FormGroup>
                            <hr style={{ borderTop: '1px solid #e6e6e6', margin: '1.5rem 0' }} />
                            <OPFormFactory formName={orderType} />

                            <Col md={4} className='offset-md-4 d-flex justify-content-around my-5'>
                                <Button type='button' variant='primary' size='lg' onClick={() => dispatch(push(ORDER_PAY_LIST))}>
                                    Cancelar
                                </Button>
                                <span className={(isFetching || getSubcodeDetailsIsFetching) ? '' : 'hidden'}>
                                    <Spinner animation='border' />
                                </span>
                                <Button
                                    type='submit'
                                    variant='success'
                                    size='lg'
                                    disabled={getSubcodeDetailsIsFetching || allowSaveButton || isFetchingAdministrativeDocument || !validationSettlementOfAssets || existingPOrderNumber || orderPayListIsFetching || !isNotEmptyArray(expedientesSeleccionados)}
                                >
                                    Guardar
                                    <FontAwesomeIcon icon={faSave} className='ml-2 text-white-color ' />
                                </Button>
                            </Col>
                        </Form>
                        {/* </useFormContext> */}
                    </FormProvider>
                </Card.Body>
            </Card>
        </Container>
    </>

};

export default OrderPayNewPage;